/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appCalendar_viewer$ref = any;
export type appCalendar_QueryVariables = {||};
export type appCalendar_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appCalendar_viewer$ref,
  |}
|};
export type appCalendar_Query = {|
  variables: appCalendar_QueryVariables,
  response: appCalendar_QueryResponse,
|};
*/


/*
query appCalendar_Query {
  viewer {
    actualPersonId
    component(name: "app_calendar")
    ...appCalendar_viewer
    id
  }
}

fragment appCalendar_viewer on Viewer {
  id
  company {
    id
    calendarEnabled
    calendarApiEnabled
    outlookCalendarApiEnabled
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_calendar"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_calendar\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appCalendar_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appCalendar_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appCalendar_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarApiEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "outlookCalendarApiEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appCalendar_Query",
    "operationKind": "query",
    "text": "query appCalendar_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_calendar\")\n    ...appCalendar_viewer\n    id\n  }\n}\n\nfragment appCalendar_viewer on Viewer {\n  id\n  company {\n    id\n    calendarEnabled\n    calendarApiEnabled\n    outlookCalendarApiEnabled\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3058e91f396c02b43027ce8851cbeca';

module.exports = node;
